import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Alert from "../utils/Alert";

export const useIsLogin = () => {
    const { isLogin, isLoading } = useSelector(state => state.login);
    const dispatch = useDispatch();

    // Axios interceptors
    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            if (error.response) {
                if (error.response.status === 401) {
                    localStorage.removeItem("cncToken");
                    dispatch({ type: "GET_LOGIN_ERR" });
                } else if (error.response.status === 500) {
                    Alert("خطا 500!", "مشکلی از سمت سرور رخ داده است!\nلطفاً مجدداً تلاش کنید.", "error");
                } else {
                    Alert(`خطا ${error.response.status}!`, error.message, "error");
                }
            } else {
                Alert("خطا!", error.message, "error");
            }
            return Promise.reject(error);
        }
    );

    const handleCheckLogin = async () => {
        dispatch({ type: "SEND_LOGIN_REQ" });
        const token = JSON.parse(localStorage.getItem("cncToken"));
        if (token) {
            const now = new Date();
            if (now.getTime() > token.expireDate) {
                localStorage.removeItem("cncToken");
                dispatch({ type: "GET_LOGIN_ERR" });
            } else {
                dispatch({ type: "GET_LOGIN_RES" });
            }
        } else {
            dispatch({ type: "GET_LOGIN_ERR" });
        }
    }

    useEffect(() => {
        handleCheckLogin();
    }, []);

    return [isLogin, isLoading];
}